import BackspaceIcon from '@mui/icons-material/Backspace';
import { IconButton, Tooltip } from '@mui/material';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-premium';
import DataGridCell from 'components/cells/DataGridCell';
import { IsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import { useTranslation } from 'react-i18next';

export function useWorkstationLinkColumns(handleDelete): GridColDef[] {
  const translationPrefix = 'entities.workstation_link';
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'destination_code',
      headerName: t(`${translationPrefix}.workstation_destination`),
      flex: 1,
      filterable: false,
      renderCell: (params) => <DataGridCell content={params.value} />
    },
    {
      field: 'weight',
      headerName: t(`${translationPrefix}.weight`),
      width: 300,
      type: 'number',
      editable: true,
      renderCell: (params) => <DataGridCell content={params.value} />
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: t(`global.actions`),
      width: 150,
      getActions: (params: GridRowParams) => [
        <IsTenantAdministrator key={1}>
          <Tooltip title={t('actions.delete')} placement="top">
            <IconButton onClick={() => handleDelete(params.row)}>
              <BackspaceIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </IsTenantAdministrator>
      ]
    }
  ];
  return columns;
}
